const includes = (substringList: string[], string: string) =>
  !!substringList.find((substring) => {
    return string?.includes(substring);
  });

export const isFalsePositive = (errorMessage: string) => {
  // ignore response code 0 from branch.io https://github.com/BranchMetrics/web-branch-deep-linking-attribution/blob/1a9b0042dcade83beea34d981c76f46f83d22214/src/3_api.js#L303
  // this code is returned when a page using this hook is detached while a branch.io request is in progress (safari browsers)
  const ignoredErrorMsg1 = 'Error in API: 0';

  // ignore errors with message - "Request blocked by client, probably adblock"
  // https://github.com/BranchMetrics/web-branch-deep-linking-attribution/blob/1a9b0042dcade83beea34d981c76f46f83d22214/src/3_api.js#L255
  // https://github.com/BranchMetrics/web-branch-deep-linking-attribution/blob/1a9b0042dcade83beea34d981c76f46f83d22214/src/1_utils.js#L198
  const ignoredErrorMsg2 = 'Request blocked by client, probably adblock';

  // ignore errors coming from calling branch methods when active branch init has failed
  const ignoredErrorMsg3 =
    'Branch SDK initialization failed, so further methods cannot be called';

  const ignoredMessages = [
    ignoredErrorMsg1,
    ignoredErrorMsg2,
    ignoredErrorMsg3
  ];

  return includes(ignoredMessages, errorMessage);
};
